import React from 'react';
import PropTypes from 'prop-types';

let STEPS_BAR = [];

const Steps = ({ step, t }) => {
  STEPS_BAR = [
    {
      num: 1,
      label: t('steps.step1')
    },
    {
      num: 2,
      label: t('steps.step2')
    },
    {
      num: 3,
      label: t('steps.step3')
    },
    {
      num: 4,
      label: t('steps.step4')
    },
    {
      num: 5,
      label: t('steps.step5')
    }
  ];

  const steps = STEPS_BAR.map((s, i) => {
    // const stepClickable = stepsValidity.get(s.num);
    // const goInClass = stepClickable ? ' go-in' : '';
    return <div key={i} className={"step " + (step === s.num ? "current" : "") + (step > s.num ? "done" : "")}>
      <div
        className={"circle"}
        // className={"circle" + goInClass}
        // onClick={() => {
        //   if(stepClickable) {
        //     goToStep(s.num);
        //   }
        // }}
        >
        {s.num}
      </div>
      <div className="line"></div>
      <span>{s.label}</span>
    </div>;
  });

  return <div className="row">
    <div className="col">
      <div className="steps py-2 py-lg-5">
        {/* Steps n° {step} */}
        {steps}
      </div>
    </div>
  </div>;
};

Steps.propTypes = {
  step: PropTypes.number,
  t: PropTypes.func
  // stepsValidity: PropTypes.object.isRequired,
  // goToStep: PropTypes.func.isRequired
};

export { Steps, STEPS_BAR };
